import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { webUI, webUIBaseUrl } from "../endpoints";
// Define a service using a base URL and expected endpoints
export const libraryCategoriesService = createApi({
  reducerPath: "libraryCategoriesService",
  baseQuery: fetchBaseQuery({ baseUrl: webUIBaseUrl }),
  tagTypes: ["libraryCategories"],
  endpoints: (builder) => ({
    getAllLibraryCategories: builder.mutation({
      query(body) {
        return {
          url: `${webUI.libraryCategoryController.getAllLibraryCategories}?page=${body.page}&size=${body.size}&sort=${body.sort}`,
          method: "GET",
          // headers: { Authorization: `Bearer ${body.token}`},
          body: body.payload,
        };
      },
    }),
     findAllLibraryCategories: builder.mutation({
      query() {
        return {
          url: `${webUI.libraryCategoryController.findAllLibraryCategories}`,
          method: "GET",
          // headers: { Authorization: `Bearer ${body.token}`},
        };
      },
    }),
     findAllGroupedLibraryCategories: builder.mutation({
      query() {
        return {
          url: `${webUI.libraryCategoryController.findAllGroupedLibraryCategories}`,
          method: "GET",
          // headers: { Authorization: `Bearer ${body.token}`},
        };
      },
    }),
    getAllLibraryCategoriesWithSearch: builder.mutation({
      query(body) {
        return {
          url: `${webUI.libraryCategoryController.getAllLibraryCategoriesBySearch}`,
          method: "POST",
          // headers: { Authorization: `Bearer ${body.token}`},
          body: body.payload,
        };
      },
    }),
    updateLibraryCategory: builder.mutation({
      query(body) {
        return {
          url: `${webUI.libraryCategoryController.updateLibraryCategory}/${body.id}`,
          method: "PUT",
          // headers: { Authorization: `Bearer ${body.token}`},
          body: body.payload,
        };
      },
    }),
    deleteLibraryCategoryById: builder.mutation({
      query(body) {
        return {
          url: `${webUI.libraryCategoryController.deleteLibraryCategoryById}/${body.id}`,
          method: "DELETE",
        };
      },
    }),
    getLibraryCategoryById: builder.mutation({
      query(body) {
        return {
          url: `${webUI.libraryCategoryController.getLibraryCategoryById}/${body.id}`,
          method: "GET",
          // headers: { Authorization: `Bearer ${body.token}`},
        };
      },
    }),
    
    saveLibraryCategory: builder.mutation({
      query(body) {
        return {
          url: `${webUI.libraryCategoryController.saveLibraryCategory}`,
          method: "POST",
          // headers: { Authorization: `Bearer ${body.token}`},
          body: body.payload,
        };
      },
    }),
  }),
});
export const {
  useGetAllLibraryCategoriesMutation,
  useGetLibraryCategoryByIdMutation,
  useDeleteLibraryCategoryByIdMutation,
  useSaveLibraryCategoryMutation,
  useUpdateLibraryCategoryMutation,
  useGetAllLibraryCategoriesWithSearchMutation,
  useFindAllLibraryCategoriesMutation,
  useFindAllGroupedLibraryCategoriesMutation
} = libraryCategoriesService;
